import script from "./pInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./pInput.vue?vue&type=script&setup=true&lang=ts"

import "./pInput.vue?vue&type=style&index=0&id=32afc45a&lang=css"

const __exports__ = script;

export default __exports__